import { render, staticRenderFns } from "./introVideo.vue?vue&type=template&id=5fbf8843&lang=true&"
import script from "./introVideo.vue?vue&type=script&lang=js&"
export * from "./introVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports